import { render } from "./FrequentlyAskedQuestions.vue?vue&type=template&id=259e4c95&scoped=true"
import script from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestions.vue?vue&type=script&lang=js"

import "./FrequentlyAskedQuestions.vue?vue&type=style&index=0&id=259e4c95&lang=css&scoped=true"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259e4c95"]])

export default __exports__